<template>
    <div>
        <!-- FASE 4 / BLOCO AA — DOC 8, 9, 22, 23, 25, 28, 32, 81, 83 -->

        <div v-if="carregando" class="loading-form" style="min-height:130px">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <div v-if="!carregando">

            <el-form @submit.native.prevent="salvar" :model="dados" ref="dados" label-position="top">

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="18" :md="18">
                        <el-form-item label="Título" prop="titulo" :rules="[$requiredBlur]" key="titulo">
                            <el-input v-model="dados.titulo" maxlength="255" :disabled="!podeEditar"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Pasta">
                            <el-select v-model="dados.pasta_id" placeholder="/ (raiz)" style="width:100%"
                                       clearable :disabled="!podeEditar" @change="moverParaPasta">
                                <el-option v-for="p in pastas" :key="p.id" :label="p.caminho" :value="p.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Descrição">
                            <el-input v-model="dados.descricao" type="textarea" :rows="2"
                                      maxlength="2000" :disabled="!podeEditar"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- DOC 83 — corpo formatado. O HTML é sanitizado no backend antes de gravar. -->
                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Conteúdo do documento">
                            <ckeditor v-if="podeEditar" v-model="dados.conteudo" :key="'ck'+dados.id"></ckeditor>
                            <div v-else class="conteudo-somente-leitura" v-html="dados.conteudo"></div>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10" v-if="podeEditar">
                    <el-col :xs="24">
                        <el-form-item class="u-text-right u-mt-15">
                            <el-button type="primary" id="btn-documento" native-type="submit">SALVAR</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <!-- DOC 49 — dados adicionais do documento -->
            <template v-if="camposAdicionais.length">
                <el-divider content-position="left">Dados adicionais</el-divider>
                <el-form label-position="top" @submit.native.prevent>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="8" v-for="c in camposAdicionais" :key="c.id">
                            <el-form-item :label="c.nome + (c.obrigatorio ? ' *' : '')">
                                <el-select v-if="c.tipo === 'lista'" v-model="valoresCampos[c.id]"
                                           :disabled="!podeEditar" clearable style="width:100%">
                                    <el-option v-for="o in opcoesDe(c)" :key="o" :label="o" :value="o"></el-option>
                                </el-select>
                                <el-date-picker v-else-if="c.tipo === 'data'" v-model="valoresCampos[c.id]"
                                                type="date" value-format="yyyy-MM-dd" style="width:100%"
                                                :disabled="!podeEditar"></el-date-picker>
                                <el-switch v-else-if="c.tipo === 'booleano'" v-model="valoresCampos[c.id]"
                                           active-value="1" inactive-value="0" :disabled="!podeEditar"></el-switch>
                                <el-input v-else v-model="valoresCampos[c.id]" :disabled="!podeEditar"
                                          :type="c.tipo === 'numero' ? 'number' : 'text'"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div v-if="podeEditar" class="u-text-right u-mb-15">
                    <el-button size="small" @click="salvarCampos">SALVAR DADOS ADICIONAIS</el-button>
                    <!-- DOC 55 -->
                    <el-button size="small" type="warning" icon="el-icon-folder-checked"
                               @click="aplicarRegra">APLICAR REGRA DE ARMAZENAMENTO</el-button>
                </div>
            </template>

            <!-- DOC 27, 31, 34, 39 — assinatura digital -->
            <el-divider content-position="left">Assinatura digital</el-divider>

            <div v-if="assinaturaAtual" class="painel-fluxo u-mb-15">
                <div class="u-mb-8">
                    <el-tag size="mini" :type="corAssinatura(situacaoAssinatura)">
                        {{ situacaoAssinatura }}
                    </el-tag>
                    <span class="meta">
                        {{ assinaturaAtual.assinados }} de {{ assinaturaAtual.total }} assinatura(s)
                    </span>
                    <el-button type="text" size="mini" @click="verManifesto">ver manifesto</el-button>
                    <!--
                      AF-3 / DOC 95 — imprimir o documento assinado é uma peça só; o pacote
                      continua existindo para quem for validar os `.p7s` no ITI.
                    -->
                    <el-button v-if="situacaoAssinatura === 'concluido'" type="text" size="mini"
                               @click="imprimirAssinado">imprimir assinado</el-button>
                    <el-button class="u-ml-10" v-if="situacaoAssinatura === 'concluido'" type="text" size="mini"
                               @click="baixarAssinado">baixar pacote</el-button>
                </div>

                <div v-for="a in assinaturaAtual.assinantes" :key="a.id" class="assinante">
                    <i :class="iconeAssinante(a.situacao)"></i>
                    {{ a.nome_usuario || a.nome_externo || a.assinante_cn }}
                    <span class="meta" v-if="a.assinado_em">· {{ a.assinado_em | formatarData }}</span>
                    <span class="meta recusa" v-if="a.motivo_recusa">· {{ a.motivo_recusa }}</span>
                </div>

                <div v-if="assinaturaAtual.minha_pendencia" class="u-mt-10 u-text-right">
                    <router-link to="/admin/documento/assinatura">
                        <el-button type="success" size="small" icon="el-icon-s-check">
                            ASSINAR ESTE DOCUMENTO
                        </el-button>
                    </router-link>
                </div>
            </div>

            <div v-else-if="podeEditar" class="u-mb-15">
                <el-button type="primary" size="small" icon="el-icon-s-check"
                           @click="dialogAssinatura = true">ENVIAR PARA ASSINATURA</el-button>
                <span class="meta u-ml-5">O documento precisa ter um arquivo anexado.</span>
            </div>

            <!-- DOC 12, 15, 29, 44 — fluxo de aprovação -->
            <el-divider content-position="left">Fluxo de aprovação</el-divider>

            <div v-if="execucaoAtual" class="painel-fluxo u-mb-15">
                <div class="u-mb-10">
                    <strong>{{ nomeFluxo }}</strong>
                    <el-tag size="mini" :type="corExecucao(execucaoAtual.situacao)">
                        {{ execucaoAtual.situacao }}
                    </el-tag>
                    <el-button v-if="execucaoAtual.situacao === 'em_andamento' && podeEditar"
                               type="text" size="mini" @click="cancelarFluxo">cancelar fluxo</el-button>
                </div>

                <el-steps :active="passoAtivo" align-center finish-status="success">
                    <el-step v-for="e in etapasFluxo" :key="e.id" :title="e.nome"
                             :description="descricaoEtapa(e)"
                             :status="statusEtapa(e)"></el-step>
                </el-steps>

                <!-- DOC 45 — decidir a etapa atribuída a mim, sem sair do documento -->
                <div v-if="detalheFluxo && detalheFluxo.sou_responsavel_agora" class="u-mt-15 u-text-right">
                    <el-button type="success" icon="el-icon-check" size="small"
                               @click="decidirEtapa(true)">APROVAR ETAPA</el-button>
                    <el-button class="u-ml-10" type="danger" icon="el-icon-close" size="small"
                               @click="dialogReprovar = true">REPROVAR</el-button>
                </div>
            </div>

            <div v-else-if="podeEditar" class="u-mb-15">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="20" :md="20">
                        <el-select v-model="fluxoEscolhido" placeholder="Escolha um fluxo" size="small"
                                style="width:260px" clearable>
                            <el-option v-for="f in fluxosAtivos" :key="f.id" :label="f.nome" :value="f.id"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :xs="24" :sm="4" :md="4">
                        <el-button type="primary" size="small" icon="el-icon-s-check" :disabled="!fluxoEscolhido" @click="iniciarFluxo">ATRIBUIR FLUXO</el-button>
                    </el-col>
                </el-row>
            </div>

            <el-divider content-position="left">Arquivos e versões</el-divider>

            <!-- DOC 25, 26, 32 — anexar em documento já criado, vários de uma vez, nova versão -->
            <el-upload
                v-if="podeEditar"
                class="area-arrastar u-mb-20"
                drag multiple action=""
                :auto-upload="false"
                :show-file-list="false"
                :on-change="aoEscolherArquivo">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">Arraste arquivos aqui ou <em>clique para selecionar</em></div>
                <div class="el-upload__tip" slot="tip">
                    Cada arquivo enviado vira uma nova versão. As versões anteriores são preservadas.
                </div>
            </el-upload>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width:60px" class="u-text-center">Versão</th>
                            <th>Arquivo</th>
                            <th class="hidden-mobile">Tipo</th>
                            <th class="hidden-mobile u-text-right" style="width:100px">Tamanho</th>
                            <th class="hidden-mobile">Enviado por</th>
                            <th class="hidden-mobile u-text-center" style="width:120px">Data</th>
                            <th class="u-text-center" style="width:120px">Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="v in versoes" :key="v.id" :class="{'versao-atual': v.id === dados.versao_atual_id}">
                            <td class="u-text-center">
                                <el-tag size="mini" :type="v.id === dados.versao_atual_id ? 'success' : 'info'">
                                    {{ v.numero }}
                                </el-tag>
                            </td>
                            <td>{{ v.nome_original }}</td>
                            <td class="hidden-mobile">{{ (v.extensao || '').toUpperCase() }}</td>
                            <td class="hidden-mobile u-text-right">{{ v.tamanho | tamanho }}</td>
                            <td class="hidden-mobile">{{ v.autor }}</td>
                            <td class="hidden-mobile u-text-center">{{ v.created_at | formatarData }}</td>
                            <td class="u-text-center acao">
                                <el-button type="info" icon="el-icon-view" size="mini" plain
                                           title="Visualizar" v-if="visualizavel(v)"
                                           @click="visualizar(v)"></el-button>
                                <el-button class="u-ml-10" type="primary" icon="el-icon-download" size="mini" plain
                                           title="Baixar" @click="baixar(v)"></el-button>
                            </td>
                        </tr>
                        <tr v-if="!versoes.length">
                            <td colspan="7" class="u-text-center u-mt-25">Nenhum arquivo anexado.</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <el-row class="u-mt-20">
                <el-col :xs="24" class="u-text-left">
                    <el-button type="default" icon="el-icon-back" @click="$router.push('/admin/documento')">
                        VOLTAR
                    </el-button>
                    <!-- DOC 19 — a auditoria no ponto em que ela importa: o próprio documento -->
                    <el-button type="default" icon="el-icon-time" @click="verHistoricoAuditoria">
                        HISTÓRICO
                    </el-button>
                    <span class="aviso-leitura" v-if="!podeEditar">
                        <i class="el-icon-lock"></i>
                        Você pode visualizar e baixar. Alterar e excluir é do proprietário do documento.
                    </span>
                </el-col>
            </el-row>
        </div>

        <!-- DOC 27, 41, 42 — enviar para assinatura -->
        <el-dialog title="Enviar para assinatura" :visible.sync="dialogAssinatura" width="560px">
            <el-form label-position="top" class="u-mt-20">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Natureza (opcional)">
                            <el-input v-model="novaAssinatura.natureza" maxlength="60"
                                      placeholder="Ex.: Portaria, Contrato"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Prazo para assinar (opcional)">
                            <el-date-picker v-model="novaAssinatura.data_limite" type="datetime"
                                            value-format="yyyy-MM-dd HH:mm:ss" style="width:100%"
                                            placeholder="Sem prazo"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="Assinantes">
                    <el-select v-model="novaAssinatura.assinantes" multiple filterable remote
                               :remote-method="buscarAssinantes" :loading="buscandoAssinante"
                               placeholder="Digite o nome" style="width:100%">
                        <el-option v-for="u in usuariosAssinatura" :key="u.id"
                                   :label="u.name" :value="u.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="dialogAssinatura = false">Cancelar</el-button>
                <el-button class="u-ml-10" type="primary" @click="enviarParaAssinatura">ENVIAR</el-button>
            </span>
        </el-dialog>

        <!-- DOC 17 — parecer obrigatório na reprovação -->
        <el-dialog title="Reprovar documento" :visible.sync="dialogReprovar" width="520px">
            <el-input v-model="parecerReprovacao" type="textarea" :rows="4" maxlength="2000"
                      placeholder="Parecer (obrigatório)"></el-input>
            <span slot="footer">
                <el-button @click="dialogReprovar = false">Cancelar</el-button>
                <el-button class="u-ml-10" type="danger" @click="decidirEtapa(false, parecerReprovacao)">REPROVAR</el-button>
            </span>
        </el-dialog>

        <!-- DOC 19 — movimentações deste documento -->
        <el-dialog title="Histórico de movimentações" :visible.sync="dialogAuditoria" width="70%">
            <table class="table table-striped">
                <thead>
                    <tr><th style="width:150px">Quando</th><th>Usuário</th>
                        <th style="width:130px">Ação</th><th>Detalhe</th></tr>
                </thead>
                <tbody>
                    <tr v-for="m in auditoria" :key="m.id">
                        <td>{{ m.created_at | formatarData }}</td>
                        <td>{{ m.usuario }}</td>
                        <td><el-tag size="mini">{{ m.acao }}</el-tag></td>
                        <td>{{ m.descricao || '—' }}</td>
                    </tr>
                    <tr v-if="!auditoria.length">
                        <td colspan="4" class="u-text-center">Nenhuma movimentação registrada.</td>
                    </tr>
                </tbody>
            </table>
        </el-dialog>

        <!-- DOC 81 — visualizar PDF, TXT e XML sem sair da tela -->
        <el-dialog :title="visualizando ? visualizando.nome_original : ''" :visible.sync="dialogVer"
                   width="80%" top="5vh" @close="fecharVisualizacao">
            <iframe v-if="urlBlob" :src="urlBlob" style="width:100%;height:65vh;border:0"></iframe>
        </el-dialog>
    </div>
</template>
<script>

import moment from 'moment'
import ckeditor from '@/shared/ckeditor/ckeditor'

export default {
    props: ['paramId'],
    filters: {
        formatarData (v) { return v ? moment(v).format('DD/MM/YYYY HH:mm') : '—' },
        tamanho (b) {
            if (!b && b !== 0) return '—'
            if (b < 1024) return b + ' B'
            if (b < 1048576) return (b / 1024).toFixed(1) + ' KB'
            return (b / 1048576).toFixed(1) + ' MB'
        }
    },
    data: () => ({
        carregando: true,
        podeEditar: false,
        dados: { id: '', titulo: '', descricao: '', conteudo: '', pasta_id: null, versao_atual_id: null, user_id: null },
        versoes: [],
        pastas: [],
        dialogVer: false,
        visualizando: null,
        urlBlob: null,
        camposAdicionais: [],
        valoresCampos: {},
        dialogAuditoria: false,
        auditoria: [],
        assinaturaAtual: null,
        dialogAssinatura: false,
        novaAssinatura: { natureza: '', data_limite: '', assinantes: [] },
        usuariosAssinatura: [],
        buscandoAssinante: false,
        fluxosAtivos: [],
        fluxoEscolhido: '',
        detalheFluxo: null,
        dialogReprovar: false,
        parecerReprovacao: ''
    }),
    computed: {
        /**
         * `detalhe/{id}` devolve o procedimento ANINHADO — `{procedimento, assinantes,
         * total, assinados, ...}`. Ler `assinaturaAtual.situacao` dava sempre `undefined`:
         * a etiqueta saía vazia e os botões de "imprimir assinado"/"baixar pacote", presos
         * a `=== 'concluido'`, nunca apareciam mesmo com o documento assinado.
         */
        situacaoAssinatura () {
            return this.assinaturaAtual && this.assinaturaAtual.procedimento
                ? this.assinaturaAtual.procedimento.situacao
                : null
        },

        /*
         * `execucao/{id}` também vem aninhado — `{execucao, fluxo, etapas, etapa_atual,
         * sou_responsavel_agora}`. O template lia `execucaoAtual`, `etapasFluxo` e
         * `passoAtivo`, que não existiam em lugar nenhum: o painel do fluxo nunca abria e
         * o console enchia de "Property or method is not defined".
         */
        execucaoAtual () {
            return this.detalheFluxo && this.detalheFluxo.execucao
                ? this.detalheFluxo.execucao
                : null
        },

        /** `fluxo` é o registro inteiro; na tela mostra-se o nome. */
        nomeFluxo () {
            return this.detalheFluxo && this.detalheFluxo.fluxo
                ? this.detalheFluxo.fluxo.nome
                : ''
        },

        etapasFluxo () {
            return this.detalheFluxo && this.detalheFluxo.etapas
                ? this.detalheFluxo.etapas
                : []
        },

        /** Passo do `el-steps`: a primeira pendente. Nenhuma pendente = fluxo encerrado. */
        passoAtivo () {
            const etapas = this.etapasFluxo
            const i = etapas.findIndex(e => e.situacao === 'pendente')
            return i < 0 ? etapas.length : i
        }
    },
    mounted () {
        this.carregar()
        this.carregarPastas()
        this.carregarCamposAdicionais()
        this.carregarFluxo()
        this.carregarAssinatura()
    },
    methods: {
        base () { return this.$store.state.config.baseUrlApi },
        auth () { return this.$store.getters.getHeaderAuth },

        erro (e) {
            window.eventBus.$emit('loading', false)
            const resp = e && e.response ? e.response.data : null
            let msg = 'Não foi possível concluir a operação.'
            if (resp && typeof resp.erro === 'string') msg = resp.erro
            else if (resp && resp.erro && resp.erro.text) msg = resp.erro.text
            window.eventBus.$emit('alert', { msg: msg, type: 'error' })
            this.$store.commit('throwException', e)
        },

        carregar () {
            this.carregando = true

            this.$axios.get(`${this.base()}/api/documento/getById/${this.paramId}`, this.auth()).then(r => {
                this.dados = r.data

                // DOC 8 — só o proprietário edita. O backend decide de novo a cada escrita;
                // isto aqui é só para a tela não oferecer o que vai ser recusado.
                const eu = this.$store.state.user
                this.podeEditar = !!(eu && Number(eu.id) === Number(r.data.user_id))

                this.carregando = false
                this.carregarVersoes()
            }).catch(e => { this.carregando = false; this.erro(e) })
        },

        carregarVersoes () {
            this.$axios.get(`${this.base()}/api/documento/versoes/${this.paramId}`, this.auth()).then(r => {
                this.versoes = r.data
            }).catch(e => { this.erro(e) })
        },

        /**
         * DOC 19 — histórico deste documento.
         *
         * Restrito a quem audita: o backend recusa os demais, e aqui a recusa vira mensagem
         * em vez de tela vazia.
         */
        corAssinatura (s) {
            if (s === 'concluido') return 'success'
            if (s === 'recusado')  return 'danger'
            if (s === 'cancelado') return 'info'
            return 'primary'
        },

        iconeAssinante (s) {
            if (s === 'assinado') return 'el-icon-circle-check confirmou'
            if (s === 'recusado') return 'el-icon-circle-close'
            return 'el-icon-time'
        },

        /** DOC 34 — o andamento das assinaturas deste documento. */
        carregarAssinatura () {
            this.$axios.get(`${this.base()}/api/documento-assinatura/do-documento/${this.paramId}`,
                this.auth()).then(r => {
                const lista = r.data || []
                if (!lista.length) { this.assinaturaAtual = null; return }

                const atual = lista.find(x => x.situacao === 'em_andamento') || lista[0]

                return this.$axios.get(`${this.base()}/api/documento-assinatura/detalhe/${atual.id}`,
                    this.auth()).then(d => { this.assinaturaAtual = d.data })
            }).catch(() => { this.assinaturaAtual = null })
        },

        buscarAssinantes (termo) {
            if (!termo || termo.length < 2) return
            this.buscandoAssinante = true
            this.$axios.post(`${this.base()}/api/documento-gestao/transferencia/usuarios`,
                { termo: termo, instituicao_id: this.dados.instituicao_id }, this.auth()).then(r => {
                this.usuariosAssinatura = r.data
                this.buscandoAssinante = false
            }).catch(() => { this.buscandoAssinante = false })
        },

        enviarParaAssinatura () {
            if (!this.novaAssinatura.assinantes.length) {
                window.eventBus.$emit('alert', { msg: 'Informe ao menos um assinante.', type: 'warning' })
                return
            }

            const payload = {
                natureza: this.novaAssinatura.natureza,
                data_limite: this.novaAssinatura.data_limite || null,
                assinantes: this.novaAssinatura.assinantes.map(id => ({ user_id: id }))
            }

            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.base()}/api/documento-assinatura/abrir/${this.paramId}`,
                payload, this.auth()).then(r => {
                window.eventBus.$emit('loading', false)
                window.eventBus.$emit('alert', { msg: 'Sucesso! - Enviado para assinatura.', type: 'success' })
                this.assinaturaAtual = r.data
                this.dialogAssinatura = false
                this.novaAssinatura = { natureza: '', data_limite: '', assinantes: [] }
                this.carregar()
            }).catch(e => { this.erro(e) })
        },

        verManifesto () {
            const cfg = Object.assign({}, this.auth())
            cfg.responseType = 'blob'
            window.eventBus.$emit('loading', true)
            this.$axios.get(`${this.base()}/api/documento-assinatura/manifesto/${this.assinaturaAtual.procedimento.id}`,
                cfg).then(r => {
                window.eventBus.$emit('loading', false)
                window.open(window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' })), '_blank')
            }).catch(e => { this.erro(e) })
        },

        /* DOC 95 — o PDF com as assinaturas embarcadas, aberto para impressão. */
        imprimirAssinado () {
            const cfg = Object.assign({}, this.auth())
            cfg.responseType = 'blob'
            window.eventBus.$emit('loading', true)
            this.$axios.get(`${this.base()}/api/documento-assinatura/baixar-assinado/${this.assinaturaAtual.procedimento.id}`,
                cfg).then(r => {
                window.eventBus.$emit('loading', false)
                window.open(window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' })), '_blank')
            }).catch(e => {
                window.eventBus.$emit('loading', false)
                if (e.response && e.response.status === 404) {
                    this.$message({
                        type: 'warning',
                        message: 'Este documento não tem versão assinada em PDF. Use o pacote de assinaturas.'
                    })
                    return
                }
                this.erro(e)
            })
        },

        baixarAssinado () {
            const cfg = Object.assign({}, this.auth())
            cfg.responseType = 'blob'
            window.eventBus.$emit('loading', true)
            this.$axios.get(`${this.base()}/api/documento-assinatura/baixar-pacote/${this.assinaturaAtual.procedimento.id}`,
                cfg).then(r => {
                window.eventBus.$emit('loading', false)
                const url = window.URL.createObjectURL(new Blob([r.data], { type: 'application/zip' }))
                const a = document.createElement('a')
                a.href = url; a.download = 'documento-assinado.zip'
                document.body.appendChild(a); a.click(); document.body.removeChild(a)
                window.URL.revokeObjectURL(url)
            }).catch(e => { this.erro(e) })
        },

        corExecucao (s) {
            if (s === 'aprovado')  return 'success'
            if (s === 'reprovado') return 'danger'
            if (s === 'cancelado') return 'info'
            return 'primary'
        },

        statusEtapa (e) {
            if (e.situacao === 'aprovado')  return 'success'
            if (e.situacao === 'reprovado') return 'error'
            return 'wait'
        },

        descricaoEtapa (e) {
            const partes = [e.responsavel]
            if (e.descricao_atividade) partes.push(e.descricao_atividade)
            if (e.parecer) partes.push('Parecer: ' + e.parecer)
            return partes.join(' · ')
        },

        /** DOC 12, 15 — a execução corrente, se houver, e os fluxos disponíveis. */
        carregarFluxo () {
            this.$axios.get(`${this.base()}/api/documento-fluxo/execucoes-documento/${this.paramId}`,
                this.auth()).then(r => {
                const emAndamento = (r.data || []).find(x => x.situacao === 'em_andamento')
                const ultima = emAndamento || (r.data && r.data.length ? r.data[0] : null)

                if (!ultima) { this.detalheFluxo = null; return }

                return this.$axios.get(`${this.base()}/api/documento-fluxo/execucao/${ultima.id}`, this.auth())
                    .then(d => { this.detalheFluxo = d.data })
            }).catch(() => { this.detalheFluxo = null })

            this.$axios.post(`${this.base()}/api/documento-fluxo/ativos`, {}, this.auth())
                .then(r => { this.fluxosAtivos = r.data })
                .catch(() => { this.fluxosAtivos = [] })
        },

        iniciarFluxo () {
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.base()}/api/documento-fluxo/iniciar/${this.paramId}`,
                { fluxo_id: this.fluxoEscolhido }, this.auth()).then(r => {
                window.eventBus.$emit('loading', false)
                window.eventBus.$emit('alert', { msg: 'Sucesso! - Fluxo iniciado.', type: 'success' })
                this.detalheFluxo = r.data
                this.fluxoEscolhido = ''
                this.carregar()
            }).catch(e => { this.erro(e) })
        },

        decidirEtapa (aprovar, parecer) {
            const etapaId = this.detalheFluxo ? this.detalheFluxo.etapa_atual : null
            if (!etapaId) return

            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.base()}/api/documento-fluxo/decidir/${etapaId}`,
                { aprovar: aprovar, parecer: parecer || null }, this.auth()).then(r => {
                window.eventBus.$emit('loading', false)
                window.eventBus.$emit('alert', {
                    msg: 'Sucesso! - ' + (aprovar ? 'Etapa aprovada.' : 'Documento reprovado.'), type: 'success'
                })
                this.detalheFluxo = r.data
                this.dialogReprovar = false
                this.parecerReprovacao = ''
                this.carregar()
            }).catch(e => { this.erro(e) })
        },

        cancelarFluxo () {
            this.$msgbox.confirm('Cancelar o fluxo de aprovação deste documento?', 'Atenção',
                { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }
            ).then(() => {
                window.eventBus.$emit('loading', true)
                this.$axios.post(`${this.base()}/api/documento-fluxo/cancelar/${this.execucaoAtual.id}`,
                    {}, this.auth()).then(r => {
                    window.eventBus.$emit('loading', false)
                    window.eventBus.$emit('alert', { msg: 'Sucesso! - Fluxo cancelado.', type: 'success' })
                    this.detalheFluxo = r.data
                    this.carregar()
                }).catch(e => { this.erro(e) })
            }).catch(() => {})
        },

        verHistoricoAuditoria () {
            window.eventBus.$emit('loading', true)

            this.$axios.get(`${this.base()}/api/documento-gestao/auditoria/de/documento/${this.paramId}`,
                this.auth()).then(r => {
                window.eventBus.$emit('loading', false)
                this.auditoria = r.data
                this.dialogAuditoria = true
            }).catch(e => { this.erro(e) })
        },

        opcoesDe (c) {
            try { return c.opcoes ? JSON.parse(c.opcoes) : [] } catch (e) { return [] }
        },

        /** DOC 49 — os dados adicionais preenchidos neste documento. */
        carregarCamposAdicionais () {
            this.$axios.get(`${this.base()}/api/documento-gestao/campo/valores/${this.paramId}`, this.auth())
                .then(r => {
                    const valores = {}
                    r.data.forEach(v => { valores[v.campo_id] = v.valor })
                    this.valoresCampos = valores
                }).catch(() => {})

            this.$axios.post(`${this.base()}/api/documento-gestao/campo/getAllPaginate`, {}, this.auth())
                .then(r => { this.camposAdicionais = (r.data.data || []).filter(c => c.ativo) })
                .catch(() => {})
        },

        salvarCampos () {
            const valores = Object.keys(this.valoresCampos).map(id => ({
                campo_id: id, valor: this.valoresCampos[id]
            }))

            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.base()}/api/documento-gestao/campo/salvar-valores/${this.paramId}`,
                { valores: valores }, this.auth()).then(() => {
                window.eventBus.$emit('loading', false)
                window.eventBus.$emit('alert', { msg: 'Sucesso! - Dados adicionais salvos.', type: 'success' })
            }).catch(e => { this.erro(e) })
        },

        /** DOC 55 — guarda o documento na pasta que a regra define, e renomeia. */
        aplicarRegra () {
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.base()}/api/documento-gestao/regra/aplicar/${this.paramId}`,
                {}, this.auth()).then(r => {
                window.eventBus.$emit('loading', false)

                if (!r.data.aplicada) {
                    window.eventBus.$emit('alert', { msg: r.data.motivo, type: 'warning' })
                    return
                }

                const partes = []
                if (r.data.mudou.pasta)  partes.push('movido para ' + r.data.mudou.pasta)
                if (r.data.mudou.titulo) partes.push('renomeado para ' + r.data.mudou.titulo)

                window.eventBus.$emit('alert', {
                    msg: 'Regra "' + r.data.regra + '": ' + partes.join(' e ') + '.', type: 'success'
                })
                this.carregar()
            }).catch(e => { this.erro(e) })
        },

        carregarPastas () {
            this.$axios.post(`${this.base()}/api/documento-pasta/arvore`, {}, this.auth()).then(r => {
                this.pastas = this.achatar(r.data)
            }).catch(e => { this.erro(e) })
        },

        achatar (nos, acc) {
            acc = acc || []
            nos.forEach(n => { acc.push(n); if (n.filhas && n.filhas.length) this.achatar(n.filhas, acc) })
            return acc
        },

        salvar () {
            this.$refs.dados.validate(valido => {
                if (!valido) return

                window.eventBus.$emit('loading', true)

                this.$axios.post(`${this.base()}/api/documento/update/${this.dados.id}`, {
                    titulo: this.dados.titulo,
                    descricao: this.dados.descricao,
                    conteudo: this.dados.conteudo
                }, this.auth()).then(r => {
                    window.eventBus.$emit('loading', false)
                    window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
                    // Recarrega: o backend sanitiza o HTML e o resultado pode diferir do enviado.
                    this.dados.conteudo = r.data.conteudo
                }).catch(e => { this.erro(e) })
            })
        },

        moverParaPasta (pastaId) {
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.base()}/api/documento/mover/${this.dados.id}`,
                { pasta_id: pastaId }, this.auth()).then(() => {
                window.eventBus.$emit('loading', false)
                window.eventBus.$emit('alert', { msg: 'Sucesso! - Documento movido.', type: 'success' })
            }).catch(e => { this.erro(e) })
        },

        aoEscolherArquivo (file) {
            if (!file || !file.raw) return

            const form = new FormData()
            form.append('arquivos[]', file.raw)

            const cfg = Object.assign({}, this.auth())
            cfg.headers = Object.assign({}, cfg.headers, { 'Content-Type': 'multipart/form-data' })

            window.eventBus.$emit('loading', true)

            this.$axios.post(`${this.base()}/api/documento/versao-enviar/${this.dados.id}`, form, cfg).then(() => {
                window.eventBus.$emit('loading', false)
                window.eventBus.$emit('alert', { msg: 'Sucesso! - Nova versão enviada.', type: 'success' })
                this.carregar()
            }).catch(e => { this.erro(e) })
        },

        visualizavel (v) {
            return ['pdf', 'txt', 'xml', 'png', 'jpg', 'jpeg', 'gif'].indexOf((v.extensao || '').toLowerCase()) >= 0
        },

        /**
         * DOC 81 — visualização.
         *
         * O arquivo vem por blob autenticado, não por URL direta: o disco é privado e o
         * download exige o token. O backend responde sempre com `attachment`; o blob local
         * é o que permite exibir sem expor o arquivo por uma URL adivinhável.
         */
        visualizar (v) {
            const cfg = Object.assign({}, this.auth())
            cfg.responseType = 'blob'

            window.eventBus.$emit('loading', true)

            this.$axios.get(`${this.base()}/api/documento/baixar/${v.id}`, cfg).then(r => {
                window.eventBus.$emit('loading', false)
                this.fecharVisualizacao()
                this.visualizando = v
                this.urlBlob = window.URL.createObjectURL(new Blob([r.data], { type: v.mime }))
                this.dialogVer = true
            }).catch(e => { this.erro(e) })
        },

        baixar (v) {
            const cfg = Object.assign({}, this.auth())
            cfg.responseType = 'blob'

            window.eventBus.$emit('loading', true)

            this.$axios.get(`${this.base()}/api/documento/baixar/${v.id}`, cfg).then(r => {
                window.eventBus.$emit('loading', false)
                const url = window.URL.createObjectURL(new Blob([r.data], { type: v.mime }))
                const a = document.createElement('a')
                a.href = url
                a.download = v.nome_original
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
                window.URL.revokeObjectURL(url)
            }).catch(e => { this.erro(e) })
        },

        fecharVisualizacao () {
            if (this.urlBlob) { window.URL.revokeObjectURL(this.urlBlob); this.urlBlob = null }
            this.visualizando = null
        }
    },
    beforeDestroy () { this.fecharVisualizacao() },
    components: { ckeditor }
}
</script>
<style scoped>
.versao-atual { background: #f0f9eb !important; }
.aviso-leitura { margin-left: 15px; color: #909399; font-size: 13px; }
.conteudo-somente-leitura {
    border: 1px solid #DCDFE6; border-radius: 4px; padding: 12px; min-height: 120px; background: #FAFAFA;
}
.area-arrastar >>> .el-upload, .area-arrastar >>> .el-upload-dragger { width: 100%; }
.area-arrastar >>> .el-upload-dragger { height: 100px; }
</style>
